import Logo from "./Logo";

function LogoView() {
  return (
    <div className="w-screen h-full relative">
      <div className="w-full h-max flex flex-row items-center absolute top-0 bottom-0 my-auto">
        <div className="bg-black grow h-px"></div>
        <div className="w-max h-max rounded-[24px] yellow-bg border-black flex justify-center px-4">
          <Logo />
        </div>
        <div className="bg-black grow h-px"></div>
      </div>
    </div>
  );
}

export default LogoView;
